import { Stack } from 'common/design-system/components-v2';
import styled from 'styled-components';

export const LayersCommandWrapper = styled(Stack)`
    max-height: 300px;
    overflow-y: scroll;
`;
